import type React from 'react';

import type { BrainAtlasType, MultiLang } from '../config';
import Functions from '../functions';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';
import XoonipsListItem from './lib/XoonipsListItem';

interface Props {
    lang: MultiLang;
    itemType: string;
    subItemType: string;
    type: BrainAtlasType;
}

const XoonipsSearchByItemType: React.FC<Props> = (props) => {
    const { lang, itemType, subItemType, type } = props;

    const searchFunc = (condition: SortCondition, func: SearchCallbackFunc) => {
        if (itemType === '') {
            const res = { total: 0, data: [] };
            func(res);
        } else {
            ItemUtil.getListByItemType(type, itemType, subItemType, condition, func);
        }
    };

    const baseUrl = ItemUtil.getItemTypeSearchUrl(type, itemType, subItemType);

    return (
        <div className="list">
            <h3>{Functions.mlang('[en]Listing item[/en][ja]アイテム一覧[/ja]', lang)}</h3>
            <XoonipsListItem lang={lang} url={baseUrl} search={searchFunc} type={type} />
        </div>
    );
};

export default XoonipsSearchByItemType;
